import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useRef, useState } from 'react';
import Avatar from '../../../../animation/jobs/Avatar.png';
import DocxIcon from '../../../../animation/jobs/Doc - vector.svg';
import DownloadIcon from '../../../../animation/jobs/download.svg';
import PdfIcon from '../../../../animation/jobs/pdf - vector.svg';
import TickIcon from '../../../../animation/jobs/Tick illustration - apply confirmation.svg';
import { ServiceApi } from '../../Service/ServiceApi';
import { store } from "./../../../../redux/store";
import './ApplyPopup.Module.css';
import PhoneInput from './PhoneInput';


const ApplyPopup = ({ open, onClose, job }) => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [resume, setResume] = useState(null);
  const [resumeUploaded, setResumeUploaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const profiledetail = store.getState().profile;
  const Token = localStorage.getItem("token");

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (profiledetail?.resumefile) {
      setResume(profiledetail.resumefile);
      setResumeUploaded(true);
    }
  }, [profiledetail,open]);

  const handleFileChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      setResume(file);
      setResumeUploaded(true);
    }
  };

  const handlePhoneChange = (phoneData) => {
  setPhone(phoneData.fullNumber);  
};


  useEffect(() => {
  }, [resumeUploaded]);

  useEffect(() => {
    
  }, [phone]);

  if (!open) return null;

  const handleDownload = () => {
    if (typeof resume === "string") {
      window.open(resume, "_blank");
    } else if (resume instanceof File) {
      const url = URL.createObjectURL(resume);
      const link = document.createElement("a");
      link.href = url;
      link.download = resume.name;
      link.click();
      URL.revokeObjectURL(url);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    if (!resume) {
      setToastMessage("Please upload a resume.");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
      return;
    }
    setIsSubmitting(true);
    try {
      const result = await ServiceApi.MainPageApplyApi(Token, job.id, resume, email, phone);
      setToastMessage(`🚀 You applied to ${job.title} successfully!`);
      setShowToast(true);
      setSubmissionSuccess(true);
      job.isApplied = {
        applied_at: result.data.applied_at
      };
      console.log('jobb', job)
    } catch (error) {
      console.error("Apply error:", error);
      setToastMessage("⚠️ You have already applied for this job.");
      setShowToast(true);
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  const handleClosePopup = () => {
     setEmail('');
    setPhone('');
    setResume(null);
    setResumeUploaded(false);
    setSubmissionSuccess(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    onClose();
  };

  return (
    <div className="overlay">
      {submissionSuccess ? (
        // Render success popup when submissionSuccess is true
        <div className="success-container">
          <div className="success-content">
            <img src={TickIcon} alt="Success" />
            <h2 className="success-title">Your application was sent to {job?.CompanyData?.company_name}!</h2>
            <p className="success-message">You can track your application in “Applied” tab of My job</p>
            <div className="success-buttons">
              <button className="ok-button" onClick={handleClosePopup}>Ok, Got it</button>
            </div>
          </div>
        </div>
      ) : (
        // Render the application form when submissionSuccess is false
        <div className="apply-popup-container">
           <div className="apply-popup-content">
          <div className="apply-popup-header">
            <h2>{job?.title}</h2>
            <span className="close-button" onClick={onClose}>
              <CloseIcon className="cross" />
            </span>
          </div>
          <div className="contact-info">
            <h3>Contact Info</h3>
            <div className="contact-details">
              <div className="Avatar">
                {profiledetail.userProfilePic ? (
                  <img
                    src={profiledetail.userProfilePic}
                    alt="User Profile"
                  />
                ) : (
                  <img src={Avatar} width={50} height={50} alt="Default Avatar" />
                )}
              </div>
              <div className="user-details">
                <p className="user-name">{profiledetail.name}</p>
                {profiledetail.organisation ? <p className="user-title">{profiledetail.organisation}</p> : ''}
                {profiledetail.address ? <p className="user-location">{profiledetail.address}</p> : ''}
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email address*</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email addresses"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone number*</label>
              <div className="phone-input-container">
              <PhoneInput
              onChange={handlePhoneChange}
              defaultCountry="in"
              preferredCountries={['in', 'us', 'gb', 'ae', 'ca']}
              required={true}
              placeholder="Enter phone number"
            />
               
              </div>
            </div>

            {showToast && <div className="Toastcard">{toastMessage}</div>}

            <div className="form-group">
              <label htmlFor="resume">Resume*</label>

              {!resumeUploaded ? (
                <div className="resume-uploaded-container">
                  <div className="resume-uploaded-inner">

                    <div className="file-info">

                      <span className="upload-date">No resume uploaded yet</span>
                    </div>
                    <div className="file-actions">
                      <div className="radio-button active"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="resume-uploaded-container">
                  <div className="resume-uploaded-inner">
                    {(() => {
                      const fileName = resume instanceof File ? resume.name : String(resume).toLowerCase();

                      if (fileName.endsWith('.pdf')) {
                        return <img src={PdfIcon} width={40} height={40} alt="PDF Icon" style={{ marginLeft: -15, marginTop: -15 }} />;
                      } else if (fileName.endsWith('.doc') || fileName.endsWith('.docx')) {
                        return <img src={DocxIcon} width={40} height={40} alt="DOCX Icon" style={{ marginLeft: -15, marginTop: -15 }} />;
                      } else {
                        return <img src={DocxIcon} width={40} height={40} alt="Resume Icon" style={{ marginLeft: -15, marginTop: -15 }} />;
                      }
                    })()}

                    <div className="file-info">
                      <span className="file-name">
                         {typeof resume === "string"
          ? resume.split("/").pop().split("-").slice(1).join("-")
          : resume?.name || "Uploaded Resume"}
                      </span>
                      <span className="upload-date">Uploaded on {new Date().toLocaleDateString()}</span>
                    </div>
                    <div className="file-actions">
                      <img src={DownloadIcon} width={18} height={18} alt="Download Icon" onClick={handleDownload} />
                      <div className="radio-button active"></div>
                    </div>
                  </div>
                </div>
              )}

              <div className="or-divider">
                {(<span>OR</span>)}
                <label htmlFor="resume-upload" className="upload-button">
                  Upload Resume
                  <input
                    type="file"
                    id="resume-upload"
                    accept=".pdf, .doc, .docx"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                  />
                </label>
                <span>PDF,DOC(2MB)</span>
              </div>
            </div>
            <div className="form-actions">
              <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
              <button type="submit" className="submit-btn">Submit application</button>
            </div>
          </form>
        </div>
     </div>
      )}
    </div>
       
  );
};

export default ApplyPopup;